const iframeResize = require(6)

module.exports = {
  iframeResize: iframeResize,
  iframeResizer: iframeResize, // Backwards compatibility
  contentWindow: require(5)
}
